import styled from 'styled-components';

import { WIDTH_SIDE_BAR, PADDING_SEPARATOR_SIDE_BAR, FONT_SEPARATOR_SIDE_BAR_ICON, COLOR_SIDE_BAR_ICON, FONT_SEPARATOR_SIDE_BAR_ICON_MOBILE } from '../../../globals';

export const StyledSeparatorSideBar = styled.div`
  width: ${WIDTH_SIDE_BAR}px; 
  text-align: center;
  color: ${COLOR_SIDE_BAR_ICON};
  padding: ${PADDING_SEPARATOR_SIDE_BAR}px;

  font-size: ${FONT_SEPARATOR_SIDE_BAR_ICON}px;

  .btn-sidebar-separator {

  }

  .btn-sidebar-separator-down {
    display: block;
  }

  .btn-sidebar-separator-right {
    display: none;
  }

  @media (max-width: 767px) {
    width: 20px;
    margin: 0px;
    height: 100%;
    font-size: ${FONT_SEPARATOR_SIDE_BAR_ICON_MOBILE}em;

    i {
      display: table-cell;
      height: 100%;
      width: 100%;
      vertical-align:middle;
      text-align:center;
    }

    .btn-sidebar-separator-down {
      display: none;
    }

    .btn-sidebar-separator-right {
      display: table;
      height: 100%;      
      vertical-align:middle;
      text-align:center;
      height: 100%;
      width: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/common/SeparatorSideBar/styles/StyledSeparatorSideBar.js